import { DocumentStatusBadge } from '#/modules/commonComponents/badge';
import { formatDateOrDash } from '#/utils/date';

/** Block A：僅狀態 */
export const stockAdjustmentSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <DocumentStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const stockAdjustmentSideMsgDetailBlock = {
  fields: [
    { label: '調整單號', value: 'adjustmentNo' },
    {
      label: '單據日',
      value: (row) => formatDateOrDash(row?.adjustmentDate),
    },
    { label: '開單原因', value: 'issueReason' },
    { label: '來源', value: 'sourceType' },
    { label: '項目數', value: 'lineCount' },
    { label: '備註', value: 'remark' },
  ],
};

export const stockAdjustmentSideMsgBlocks = [
  stockAdjustmentSideMsgStatusBlock,
  stockAdjustmentSideMsgDetailBlock,
];
